import React, { useState, useEffect } from 'react';
import { isHauptadmin, CheckRecht } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { useTranslate, useRecordContext, useListContext, usePermissions, Pagination, 
  List, Datagrid, 
  TextField, SelectField, DateField, Button, 
  TextInput }  from 'react-admin';
import CachedIcon from '@mui/icons-material/Cached';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { Input, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, CircularProgress } from '@mui/material';
import MTextField from '@mui/material/TextField';
import get from 'lodash/get';

const actionChoices = [
  { id: 'A', name: 'bw.rep.history.created'},
  { id: 'E', name: 'bw.rep.history.edited'},
  { id: 'D', name: 'bw.rep.history.deleted'},
  { id: 'S', name: 'bw.rep.history.canceled'},
  { id: 'H', name: 'bw.rep.history.hidden'},
]

const InfoLabel = () => {
  const tr = useTranslate();
  return (
    <div>{tr('bw.rep.history.infolabel')}</div>
  )
}

const listFilter = [
  <TextInput source="res_no" alwaysOn label="Res No" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />,
  <InfoLabel source="info" alwaysOn />
];

const TimezoneDateField = (props) => {
  const record = useRecordContext();
  if(!record?.htz)return (<div>Time zone not set</div>)
  return (
    <DateField {...props} source="datum" label="Hostel time" showTime locales="de-CH" options={{ timeZone: record?.htz, timeZoneName:'shortOffset' }} />
  )
}

const InfoField = () => {
  const record = useRecordContext();
  if(!record || !record.li_diff)return
  return (
    <div style={{ maxWidth: '30em' }}>
      { record?.li_diff?.res?.gast && <DiffField source="res.gast" /> }
      { record?.li_diff?.res?.ankunft && <DiffField source="res.ankunft" /> }
      { record?.li_diff?.res?.dauer && <DiffField source="res.dauer" /> }
      { record?.li_diff?.res?.abreise && <DiffField source="res.abreise" /> }
      { record?.li_diff?.res?.anzPers && <DiffField source="res.anzPers" /> }
      { record?.li_diff?.res?.agent && <DiffField source="res.agent" /> }
      { record?.li_diff?.res?.status && <DiffField source="res.status" textRef /> }
      { record?.li_diff?.res?.buchungskanal && <DiffField source="res.buchungskanal" /> }
      { record?.li_diff?.res?.wichtig && <DiffField source="res.wichtig" /> }
      { record?.li_diff?.res?.erinnerung && <DiffField source="res.erinnerung" /> }
      { record?.li_diff?.res?.bezahlt && <DiffField source="res.bezahlt" /> }
      { record?.li_diff?.res?.netto && <DiffField source="res.netto" /> }
      { record?.li_diff?.res?.totalservice && <DiffField source="res.totalservice" /> }
      { record?.li_diff?.res?.total && <DiffField source="res.total" /> }
      { record?.li_diff?.res?.due && <DiffField source="res.due" /> }
      { record?.li_diff?.res?.bemerkung && <DiffField source="res.bemerkung" /> }
    </div>
  )
}

const HistDetails = () => {
  return (
    <div style={{ display: 'flex', gap: '2em' }}>
      <div style={{ maxWidth: '25%' }}>
        <DiffField source="res.gast" />
        <DiffField source="res.ankunft" />
        <DiffField source="res.dauer" />
        <DiffField source="res.abreise" />
        <DiffField source="res.anzPers" />
        <DiffField source="res.agent" />
        <DiffField source="res.status" textRef />
        <DiffField source="res.buchungskanal" />
        <DiffField source="res.wichtig" />
        <DiffField source="res.erinnerung" />
        <DiffField source="res.bezahlt" />
        <DiffField source="res.netto" />
        <DiffField source="res.totalservice" />
        <DiffField source="res.total" />
        <DiffField source="res.due" />
        <DiffField source="res.bemerkung" />
      </div>
      <div>
        <Table fields={['bett']} tab='personen' title="bw.rep.history.beds" />
      </div>
      <div>
        <Table fields={['bett', 'geschlecht', 'ak', 'preis', 'gast']} tab='personen' title="bw.rep.history.details" />
      </div>
      <div>
        <div>
          <Table fields={['anzahl', 'bezeichnung', 'preis', 'betrag']} tab='service' title="bw.rep.history.service" />
        </div>
        <div style={{ marginTop: '1em' }} >
          <Table fields={['datum', 'bezeichnung', 'text', 'betrag']} tab='zahlungen' title="bw.rep.history.zahlungen" />
        </div>
      </div>
    </div>
  )
}

const Table = ({tab, fields, title}) => {
  const tr = useTranslate();
  const record = useRecordContext();
  if(!record)return
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${fields.length}, auto)`, columnGap: '.5em' }} >
      { title && <div style={{ gridColumn: `span ${fields.length}` }} ><b>{tr(title)}</b></div>}
      { record.loginfo[tab].map((row, ri)=>
          //<div style={{ display: 'flex', flexWrap: 'wrap', gap: '.5em' }}>
            {return fields.map(col => <DiffField source={tab+"."+ri+"."+col} showTitle={false} />)}
          //</div>
      ) }
    </div>
  )
}
  
const DiffField = ({source, showTitle=true, textRef=false}) => {
  const tr = useTranslate();
  const record = useRecordContext();
  if(!record)return
  const value = get(record, 'loginfo.'+source, '');
  const is_diff = get(record, 'li_diff.'+source, false);
  const style = is_diff?{fontWeight: 'bold'}:{}
  return (
    <div style={style}>
      { showTitle && <span>{tr('bw.rep.history.'+source)}: </span> }
      { textRef===false && <span>{value}</span> }
      { textRef===true && <span>{tr('bw.rep.history.val.'+source+'.'+value)}</span> }
    </div>
  )
}

const CustomPagination = () => {
  const { page, perPage, setPage, total } = useListContext();
  const totalPages = Math.ceil(total / perPage);

  const handlePageChange = (event) => {
    const pageNumber = parseInt(event.target.value, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <Pagination page={page} perPage={perPage} setPage={setPage} total={total} rowsPerPageOptions={[5,10,25,50,100,500]} />
      <Input type="number" value={page} onChange={handlePageChange} style={{ width: 50, marginLeft: 10 }} />
    </div>
  );
};

const CustomActions = () => {
  const tr = useTranslate();
  const { filterValues, refetch } = useListContext();
  const [cnt, setCnt] = useState(0)
  const [resData, setResData] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const { permissions } = usePermissions();
  useEffect(() => {
    if(filterValues?.res_no){
      dataProvider.getList('repHistory/res', {pagination: { page: 1, perPage: 999 },sort: { field: 'id', order: 'DESC' }, filter: {res_nr: filterValues?.res_no}})
      .then(res  => {
        setResData(res?.data[0])
      })
    }
  }, [filterValues, cnt]);
  
  const deleteRes = (del) => {
    dataProvider.update('repHistory/delete', {id: filterValues?.res_no, data: { text, del, id_parent: resData?.id_parent }})
    .then(res  => {
      setConfirm(false)
      setCnt(cnt+1)
      refetch()
    })
  }

  const reactivateRes = () => {
    dataProvider.update('repHistory/reactivate', {id: filterValues?.res_no })
    .then(res  => {
      setCnt(cnt+1)
      refetch()
    })
  }
  
  const rebuildIndex = () => {
    setLoading(true)
    dataProvider.update('repHistory/rebuild', {id: filterValues?.res_no, data: { res: true} })
    .then(res  => {
      setCnt(cnt+1)
      setLoading(false)
      refetch()
    })
  }
  
  if(!resData || resData.length === 0 || !permissions)return
  const recht = permissions.reduce((res, r)=>{return r.route==="repHistory"?r.recht:res}, -1);
  return (
    <div style={{ display: 'flex' }}>
      { isHauptadmin() && <Button disabled={loading} onClick={() => rebuildIndex()} style={{ minWidth: '15em' }} label="bw.rep.history.rebuild" >
        {loading===false?<CachedIcon />:<CircularProgress size={12}/>}
      </Button>}
      { resData.status===5 && <Tooltip label="bw.rep.history.reactivateTooltip">
        <Button sx={{color: 'green'}} onClick={() => reactivateRes()} label="bw.rep.history.reactivate">
          <RestoreFromTrashIcon />
        </Button>
      </Tooltip>}
      { recht >= 2 && 
        <Button sx={{color: 'red'}} onClick={() => setConfirm(true)} label="bw.rep.history.delete">
          <DeleteIcon />
        </Button>
      }
      <Dialog open={confirm} onClose={()=>setConfirm(false)} >
        <DialogTitle>{tr("bw.rep.history.deletetitle")+filterValues?.res_no} </DialogTitle>
        <DialogContent sx={{"form > div":{margin:"16px 0"}}} >
          <div>{tr("bw.rep.history.deltext")}</div>
          <MTextField fullWidth multiline value={text} onChange={ev=>setText(ev.target.value)} />
        </DialogContent>
        <DialogActions>
          { resData?.status !== 5 && <Button onClick={()=>deleteRes(false)} color="primary">
            <span>{tr("bw.rep.history.cancel")}</span>
          </Button> }
          <CheckRecht route="repHistory" level={2}>
            <Button onClick={()=>deleteRes(true)} color="primary">
              <span>{tr("bw.rep.history.defdelete")}</span>
            </Button>
          </CheckRecht>
        </DialogActions>
      </Dialog>        
    </div>
  )
}

const InfoGroupField = () => {
  const tr = useTranslate();
  const record = useRecordContext();
  const { setFilters } = useListContext();
  if(!record)return
  return (
    <div style={{ marginLeft:'.7em', marginRight: '.7em'}}>
      <div>
        <span>{tr('bw.rep.history.element')}: </span> 
        { record.action==='D'?
          (record.bem===0?<span></span>:<span>{get(record, 'bem', '')}</span>)
          :
          (<>
            <span>{get(record, 'element', '')}</span>
            <Button onClick={()=>setFilters({ res_no: get(record, 'element', '')})} sx={{ p: 0, ml: '0.3em', minWidth: 'auto', mt: '-.17em' }} color="primary">
              <ArrowForwardIcon />
            </Button>
          </>)
        }
      </div>
      <div>
        Local: <DateField source="datum" label="Localtime" showTime locales="de-CH" options={{ timeZoneName:'shortOffset' }} />
        <br />
        Hostel: <TimezoneDateField source="datum" label="Hostel time" />
        <br />
        <SelectField source="action" choices={actionChoices} />
        &nbsp;/&nbsp; 
        <TextField source="portal_user" />
      </div>
      <div>
        <span>{tr('bw.rep.history.count')}: </span> 
        <span>{get(record, 'count', '')}</span>
      </div>
      <div>{tr('bw.rep.history.reservations')}: </div> 
      <div>{get(record, 'content', '').replace(/,/g, ', ')}</div>
      {isHauptadmin() && 
        <div>
          <span>id: </span> 
          <span>{get(record, 'id', '')}</span>
        </div>
      }
    </div>
  )
}

const GroupEmpty = () => {
  const tr = useTranslate();
  return (
    <div style={{ padding: '1em' }}>{tr('bw.rep.history.grpempty')}</div>
  )
}

const GroupList = () => {
  return (
    <List filter={{group: true}} sort={{ field: 'datum', order: 'DESC' }} perPage={25} exporter={false} style={{ height: '87vh', overflowY: 'auto', minWidth: '20em' }} /*pagination={<CustomPagination />}*/ >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} empty={<GroupEmpty />} >
        <InfoGroupField label="bw.rep.history.group" />
      </Datagrid>
    </List>
  )
}

const ListForm = (props) => {
  return (
    <List actions={<CustomActions />} filters={listFilter} sort={{ field: 'datum', order: 'DESC' }} 
      pagination={<CustomPagination />} aside={<GroupList />} perPage={50} empty={false} 
    >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} expand={<HistDetails />} 
      rowSx={() => ({ verticalAlign: 'top', '& .MuiTableCell-root:nth-of-type(n+2)': { pt: '.5em'} })} >
        <DateField source="datum" showTime locales="de-CH" options={{ timeZoneName:'shortOffset' }} />
        <TimezoneDateField source="datum" label="resources.repHistory.fields.hosteltime" />
        <SelectField source="action" choices={actionChoices} />
        <TextField source="portal_user" />
        <InfoField label="info" />
      {isHauptadmin() &&
        <TextField source="id" textAlign="right" />
      }
      </Datagrid>
    </List>
  )
}

const RepHistory = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} />
  )
}
export default RepHistory